module.exports = __webpack_public_path__ + "img/img_05.89ae9000.webp";